"use client";

import { SelectField, TextField } from "@/components/tool-kit/primitives";
import type { IV_DRIP_RATE_CALCULATOR_STRINGS } from "@/components/tools/iv-drip-rate-calculator";
import { useToolNumber } from "@/components/tools/tool-ui";
import { t } from "@/lib/i18n/interpolate";
import { DROP_FACTORS } from "@/lib/tool-kit/stats-clinical/iv-drip";

/*
 * The drop-factor and rounding fields of the IV drip calculator. Strings are the widget's own.
 */

type Strings = typeof IV_DRIP_RATE_CALCULATOR_STRINGS;

export const CUSTOM_FACTOR = "custom";
const MICRODRIP = 60;

export function FactorFields({
  strings,
  showFactor,
  showRounding,
  dropFactor,
  onDropFactor,
  customFactor,
  onCustom,
  rounding,
  onRounding,
}: {
  strings: Strings;
  showFactor: boolean;
  showRounding: boolean;
  dropFactor: string;
  onDropFactor: (value: string) => void;
  customFactor: string;
  onCustom: (value: string) => void;
  rounding: string;
  onRounding: (value: string) => void;
}) {
  const fmt = useToolNumber();
  return (
    <div className="grid gap-4 sm:grid-cols-3">
      {showFactor ? (
        <SelectField
          hint={strings.dropFactorHint}
          id="ivd-df"
          label={strings.dropFactorLabel}
          onChange={onDropFactor}
          options={[
            ...DROP_FACTORS.map((value) => ({
              value: String(value),
              label: t(
                value === MICRODRIP
                  ? strings.dropFactorMicro
                  : strings.dropFactorOption,
                { value: fmt(value) }
              ),
            })),
            { value: CUSTOM_FACTOR, label: strings.dropFactorCustom },
          ]}
          value={dropFactor}
        />
      ) : null}
      {showFactor && dropFactor === CUSTOM_FACTOR ? (
        <TextField
          id="ivd-custom"
          label={strings.customDropFactor}
          numeric
          onChange={onCustom}
          value={customFactor}
        />
      ) : null}
      {showRounding ? (
        <SelectField
          id="ivd-round"
          label={strings.roundingLabel}
          onChange={onRounding}
          options={[
            { value: "0", label: strings.roundWhole },
            { value: "1", label: strings.roundTenth },
          ]}
          value={rounding}
        />
      ) : null}
    </div>
  );
}
